const config = {
    minViewportWidth: 15, // 15 x 16 = 240px
    maxViewportWidth: 240, // 160 x 16 = 3840px
    barHeightDesktop: 45,
    barHeightMobile: 71
}

export default config;